/* eslint-disable */
import React, { Component, createContext,useState } from 'react';
import PropTypes from 'prop-types';
import Login from 'src/pages/Login';

export const UserContext = createContext({ user: null });

const  UserProvider = (props)=> {

  const { children } = props;
  
  let persistedUser = null
  try{
    persistedUser = JSON.parse(localStorage.getItem("user"))
  }catch(Error){
    persistedUser = {}
  }

  const [user, setUser] = useState(persistedUser);
  const userAndSetter = {user, setUser}

  React.useEffect(() => {
    localStorage.setItem('user', JSON.stringify(user));
  }, [user]);

  return (
      <UserContext.Provider value={userAndSetter}>
        {children}
      </UserContext.Provider>
    );
  }

UserProvider.propTypes = {
  children: PropTypes.object
};
export default UserProvider;
